<template>
  <div class="dvg">
    <div v-for="o in items" :key="o.key || o.name" v-tip="o.tip" class="dvrow">
      <span class="nm"><span v-if="o.tag" class="axtag" :style="{background: o.tag.c}">{{ o.tag.t }}</span><span :title="o.name">{{ o.name }}</span></span>
      <span class="bar"><i :style="{width: o.pos + '%', background: 'var(--sd-pos)'}" /><i :style="{width: o.nu + '%', background: 'var(--sd-neu)'}" /><i :style="{width: o.neg + '%', background: 'var(--sd-neg)'}" /></span>
      <span class="pv num-ltr" :style="{color: stC(o.pos)}">{{ o.pos }}%</span>
      <span v-if="withDelta" class="dl"><sd-delta-chip v-if="o.delta != null" :d="o.delta" /></span>
    </div>
  </div>
</template>
<script>
/* Positive / neutral / negative stacked rows. items: [{ name, pos, nu, neg, tag?: {t,c}, delta?, tip? }] */
import { stC } from '../lib/format.js'
import SdDeltaChip from './DeltaChip.vue'
export default { name: 'SdDivergingRows', components: { SdDeltaChip }, props: { items: { type: Array, default: () => [] }, withDelta: Boolean }, methods: { stC } }
</script>
